module.exports = __webpack_public_path__ + "static/img/2.e7cd99c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/1/zh/2.png
// module id = eF1O
// module chunks = 0